import React, { useMemo } from "react";
import orderBy from "lodash/orderBy";
import { PostFieldLabel, PlatformUsage } from "components/Posts/PostForm";
import { FIELDS } from "constants/PostFormFields";
import PostFieldError from "components/Posts/PostForm/PostFieldError/PostFieldError";
import { FormSize, FormThemeProvider } from "ui/ecosystems/forms";
import { MultiSelect } from "@/components/ui/multi-select";

const EMPTY_BOARD_IDS = [];

const PinterestBoards = ({
  post,
  selectedPlatform,
  platforms,
  account,
  disabled = false,
  onChange,
  errors,
  className = "",
}) => {
  const boards = useMemo(
    () =>
      orderBy(
        account.boards || [],
        [(board) => board.name.toLowerCase()],
        ["asc"]
      ).map((board) => ({
        id: board.id,
        value: board.id,
        label: board.name,
      })),
    [account.boards]
  );
  const selectedBoardIds = post[FIELDS.PI_BOARDS] || EMPTY_BOARD_IDS;

  const selected = useMemo(
    () => boards.filter((board) => selectedBoardIds.includes(board.id)),
    [boards, selectedBoardIds]
  );

  const handleCategoryChange = (selectedBoards) => {
    if (!selectedBoards || selectedBoards.length === 0) {
      onChange([]);
      return;
    }
    onChange(selectedBoards.map((board) => board.id));
  };

  return (
    <div className={className}>
      <div className="flex items-center">
        <PostFieldLabel className="mb-2 mr-4">
          Board{selected && selected.length > 1 ? "s" : ""} for{" "}
          {account.loginAlias || account.login}
        </PostFieldLabel>
        <PlatformUsage
          platforms={platforms}
          field={FIELDS.PI_BOARDS}
          selectedPlatform={selectedPlatform}
        />
      </div>
      {boards && boards.length > 0 && (
        <FormThemeProvider size={FormSize.large}>
          <MultiSelect
            value={selected}
            onChange={handleCategoryChange}
            options={boards}
            disabled={disabled}
          />
        </FormThemeProvider>
      )}
      <PostFieldError
        className="mt-4"
        fields={[FIELDS.PI_BOARDS]}
        errors={errors}
      />
    </div>
  );
};

export default PinterestBoards;
